export default __webpack_public_path__ + "static/media/goshen48.64560d2a.jpg";